import { AxiosError } from "axios";
import Order from "../interfaces_and_types/orderType";
import customFetch from "./CustomFetchFunction";
import { Url } from "./URL";

const getOrders = async (old: boolean, lastID: number, token: string) => {
  type T = { orders: Order[]; message: string };
  let returnVal: { orders: Order[]; status: number; message: string };
  returnVal = await customFetch<T>(
    Url + `/getOrdersList/place/orders/${old ? "old" : "new"}`,
    "POST",
    token,
    JSON.stringify({
      lastID,
    }),
  )
    .then((result) => {
      console.log("fetch GET current Orders = ", result);
      return {
        orders: result.data.orders,
        status: result.status,
        message: result.data.message,
      };
    })
    .catch((error: AxiosError<T>) => {
      if (error.isAxiosError) {
        console.error(
          "current Orders error: ",
          error.response?.status,
          " ",
          error.response?.data.message,
        );
        return error.response !== undefined
          ? {
              orders: error.response.data.orders,
              status: error.response.status,
              message: error.response.data.message,
            }
          : {
              orders: [],
              status: 500,
              message: "server error",
            };
      }
      console.error("current Orders error: ", error);
      return {
        orders: [],
        status: 500,
        message: "server error",
      };
    });

  return returnVal;
};

const getOrdersStatus = async (token: string) => {
  type T = {
    isWaiting: number;
    isPreparing: number;
    refused: number;
    isReady: number;
    message: string;
  };

  let returnVal: {
    isWaiting: number;
    isPreparing: number;
    refused: number;
    isReady: number;
    message: string;
    status: number;
  };

  returnVal = await customFetch<T>(
    Url + `/getOrdersList/place/orders/status/`,
    "GET",
    token,
  )
    .then((result) => {
      console.log("fetch GET Orders status = ", result);
      return {
        isWaiting: result.data.isWaiting,
        isPreparing: result.data.isPreparing,
        refused: result.data.refused,
        isReady: result.data.isReady,
        message: result.data.message,
        status: result.status,
      };
    })
    .catch((error: AxiosError<T>) => {
      if (error.isAxiosError) {
        console.error(
          "Orders status error: ",
          error.response?.status,
          " ",
          error.response?.data.message,
        );
        return error.response !== undefined
          ? {
              isWaiting: error.response.data.isWaiting,
              isPreparing: error.response.data.isPreparing,
              refused: error.response.data.refused,
              isReady: error.response.data.isReady,
              message: error.response.data.message,
              status: error.response.status,
            }
          : {
              isWaiting: 0,
              isPreparing: 0,
              refused: 0,
              isReady: 0,
              message: "server error",
              status: 500,
            };
      }
      console.error("Orders status error: ", error);
      return {
        isWaiting: 0,
        isPreparing: 0,
        refused: 0,
        isReady: 0,
        message: "server error",
        status: 500,
      };
    });

  return returnVal;
};

const updateOrder = async (
  id: number,
  updateType: number,
  token: string,
  estimatedTime?: string,
) => {
  type T = { message: string; isPreparing: number; refused: number };

  let returnVal: {
    message: string;
    isPreparing: number;
    refused: number;
    status: number;
  };
  returnVal = await customFetch<T>(
    Url + `/orderUpdate/order/update/${id}`,
    "PUT",
    token,
    JSON.stringify({
      updateType: updateType,
      ...(estimatedTime !== undefined ? { estimatedTime } : {}),
    }),
  )
    .then((result) => {
      console.log("fetch GET order after update= ", result);
      return {
        message: result.data.message,
        isPreparing: result.data.isPreparing,
        refused: result.data.refused,
        status: result.status,
      };
    })
    .catch((error: AxiosError<T>) => {
      if (error.isAxiosError) {
        console.error(
          "order after update error: ",
          error.response?.status,
          " ",
          error.response?.data.message,
        );
        return error.response !== undefined
          ? {
              isPreparing: error.response.data.isPreparing,
              refused: error.response.data.refused,
              message: error.response.data.message,
              status: error.response.status,
            }
          : {
              isPreparing: 0,
              refused: 0,
              message: "server error",
              status: 500,
            };
      }
      console.error("order after update error: ", error);
      return {
        isPreparing: 0,
        refused: 0,
        message: "server error",
        status: 500,
      };
    });

  return returnVal;
};

const reportPickupNoShow = async (
  id: number,
  token: string,
  reason: "customer_no_show" | "refuse_to_pay" = "customer_no_show",
) => {
  type T = { message: string };

  let returnVal: {
    message: string;
    status: number;
  };
  returnVal = await customFetch<T>(
    Url + `/orderUpdate/order/pickup_no_show/${id}`,
    "PUT",
    token,
    JSON.stringify({ reason }),
  )
    .then((result) => {
      console.log("fetch PUT pickup_no_show= ", result);
      return {
        message: result.data.message,
        status: result.status,
      };
    })
    .catch((error: AxiosError<T>) => {
      if (error.isAxiosError) {
        console.error(
          "pickup_no_show error: ",
          error.response?.status,
          " ",
          error.response?.data.message,
        );
        return error.response !== undefined
          ? {
              message: error.response.data.message,
              status: error.response.status,
            }
          : {
              message: "server error",
              status: 500,
            };
      }
      console.error("pickup_no_show error: ", error);
      return {
        message: "server error",
        status: 500,
      };
    });

  return returnVal;
};

const UpdateOrderItem = async (
  id: number,
  itemOrderID: number,
  token: string,
) => {
  type T = { message: string; orderReady: boolean };
  console.log(token, id, itemOrderID);
  let returnVal: { message: string; orderReady: boolean; status: number };
  returnVal = await customFetch<T>(
    Url + `/orderUpdate/order/item/update/${id}`,
    "PUT",
    token,
    JSON.stringify({
      itemID: itemOrderID,
    }),
  )
    .then((result) => {
      console.log("fetch GET order item after update= ", result);
      return {
        message: result.data.message,
        orderReady: result.data.orderReady,
        status: result.status,
      };
    })
    .catch((error: AxiosError<T>) => {
      if (error.isAxiosError) {
        console.error(
          "order item after update error: ",
          error.response?.status,
          " ",
          error.response?.data.message,
        );
        return error.response !== undefined
          ? {
              orderReady: error.response.data.orderReady,
              message: error.response.data.message,
              status: error.response.status,
            }
          : {
              orderReady: false,
              message: "server error",
              status: 500,
            };
      }
      console.error("order item after update error: ", error);
      return {
        orderReady: false,
        message: "server error",
        status: 500,
      };
    });

  return returnVal;
};

const setEstimatedTime = async (
  id: number,
  estimatedTime: string,
  token: string,
) => {
  type T = { message: string };

  let returnVal: { message: string; status: number };
  returnVal = await customFetch<T>(
    Url + `/orderUpdate/order/set_estimated_time/${id}`,
    "PUT",
    token,
    JSON.stringify({
      estimatedTime,
    }),
  )
    .then((result) => {
      console.log("fetch GET setEstimatedTime after update= ", result);
      return {
        message: result.data.message,
        status: result.status,
      };
    })
    .catch((error: AxiosError<T>) => {
      if (error.isAxiosError) {
        console.error(
          "setEstimatedTime error: ",
          error.response?.status,
          " ",
          error.response?.data.message,
        );
        return error.response !== undefined
          ? {
              message: error.response.data.message,
              status: error.response.status,
            }
          : {
              message: "server error",
              status: 500,
            };
      }
      console.error("setEstimatedTime error: ", error);
      return {
        message: "server error",
        status: 500,
      };
    });

  return returnVal;
};

const UpdateOrderPickedUp = async (id: number, token: string) => {
  type T = { message: string };

  let returnVal: { message: string; status: number };
  returnVal = await customFetch<T>(
    Url + `/orderUpdate/order/update/pickedup`,
    "PUT",
    token,
    JSON.stringify({
      id,
    }),
  )
    .then((result) => {
      console.log("fetch GET UpdateOrderPickedUp after update= ", result);
      return {
        message: result.data.message,
        status: result.status,
      };
    })
    .catch((error: AxiosError<T>) => {
      if (error.isAxiosError) {
        console.error(
          "UpdateOrderPickedUp error: ",
          error.response?.status,
          " ",
          error.response?.data.message,
        );
        return error.response !== undefined
          ? {
              message: error.response.data.message,
              status: error.response.status,
            }
          : {
              message: "server error",
              status: 500,
            };
      }
      console.error("UpdateOrderPickedUp error: ", error);
      return {
        message: "server error",
        status: 500,
      };
    });

  return returnVal;
};

export {
  getOrders,
  getOrdersStatus,
  updateOrder,
  UpdateOrderItem,
  setEstimatedTime,
  UpdateOrderPickedUp,
  reportPickupNoShow,
};
